import { SEO_FIELDS_SLUG } from 'common/SeoFields/constants'
import { NEWS_CARD_SLUG } from './constants'
import { FAQ_SLUG } from 'common/Faq/constants'
import { WYSIWYG_SLUG } from 'common/WYSIWYG/constants'

import type { DataSet } from './types'

import { initialSEOData } from 'common/SeoFields/interfaces'
import { initialWYSIWYGData } from 'common/WYSIWYG/interfaces'
import { initialNewsCardData } from './forms/news-card/interfaces'
import { initialFAQData } from 'common/Faq/interfaces'

export const initialDataSet: DataSet = {
  [SEO_FIELDS_SLUG]: initialSEOData,
  [NEWS_CARD_SLUG]: initialNewsCardData,
  [FAQ_SLUG]: initialFAQData,
  [WYSIWYG_SLUG]: initialWYSIWYGData,
}
